module.exports = __webpack_public_path__ + "img/永年标准件.b2e72b0f.jpg";